import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useCallApi from "../../hooks/useCallApi";
import PushNotificationApi from "../../api/pushNotification";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useFormik } from "formik";
import pushNotificationValidations from "../../validations/pushNotification";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";

const usePushNotificationContainer = () => {
  const navigate = useNavigate();
  const { schema, pages } = useContent();
  const { pushNotifications } = pages;
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage } = useAlert();
  const { isRTL } = useRTL();

  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    setPageLoading(false);
  }, [isRTL]);

  const initialValuesPushNotification = {
    message: "",
  };

  const handleSubmit = (values: any) => {
    callApi(PushNotificationApi.create(values), (result: any) => {
      setTimeout(
        () => setSuccessMessage(pushNotifications.createPushNotification),
        1000
      );
      navigate(Routes.pushNotifications);
    });
  };

  const pushNotificationFormik: any = useFormik({
    enableReinitialize: true,
    initialValues: initialValuesPushNotification,
    validationSchema: () => pushNotificationValidations(schema),
    onSubmit: (values: any) => handleSubmit(values),
  });

  return {
    pageLoading,
    pushNotificationFormik,
    loading,
  };
};

export default usePushNotificationContainer;
